'use client';

import { Box, Typography } from '@wishket/design-system';

import { ItemContainer, Root, TypographyChip } from './Chart.parts';
import {
  DesktopDefaultStatisticsChart,
  MobileDefaultStatisticsChart,
} from './ArticleDetailDefaultStatisticsChart.parts';

const ArticleDefaultGuestStatisticsChart = () => {
  return (
    <Root>
      <Typography
        variant="body1"
        className="flex flex-wrap items-center gap-1.5"
      >
        <TypographyChip>데이터</TypographyChip>
        <Typography variant="body1">를 열심히 수집하고 있어요.</Typography>
      </Typography>
      <Box className="-mx-4 flex gap-4 overflow-x-scroll px-4 scrollbar-hide">
        <ItemContainer className="min-w-[272px] p-4 tablet:min-w-[460px] tablet:p-5">
          <Typography variant="body2" className="font-medium text-w-gray-900">
            직무 및 연차
          </Typography>
          <Box className="hidden tablet:block">
            <DesktopDefaultStatisticsChart className="w-full" />
          </Box>
          <Box className="tablet:hidden">
            <MobileDefaultStatisticsChart className="w-full" />
          </Box>
        </ItemContainer>
        <ItemContainer className="min-w-[184px] max-w-[184px] p-4 tablet:p-5">
          <Typography variant="body2">많이 본 직무의 기술</Typography>
          <Box className="flex h-[78px] items-center justify-center">
            <Typography variant="body2" className="text-w-gray-500">
              데이터 수집 중
            </Typography>
          </Box>
        </ItemContainer>
      </Box>
    </Root>
  );
};

export default ArticleDefaultGuestStatisticsChart;
